import { useState, useEffect, useContext } from 'react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { DealerContext } from '@/context/DealerContext'
import PersistedLink from './PersistedLink'

const Header = () => {
  const navLinkClasses = `inline-flex relative items-center h-full text-[var(--nav-text)] max-sm:hidden max-sm:[&.active]:inline-flex order-2 [&.active]:font-[var(--font-weight-bold)] [&.active]:order-1 [&.active]:text-[var(--brand-1)] hover:text-[var(--nav-text-hover)] text-center text-sm transition duration-300 laeding-[1] [&.active]:before:content-[""] [&.active]:before:block [&.active]:before:absolute [&.active]:before:left-0 [&.active]:before:bottom-0
   [&.active]:before:w-full [&.active]:before:h-1 [&.active]:before:rounded-sm [&.active]:before:bg-[var(--nav-text-hover)] pt-1`
  const navLinkClassesMobile = 'inline-flex items-center h-full text-[var(--nav-text)] [&.active]:hidden hover:text-[var(--nav-text-hover)] text-center text-sm transition duration-300 laeding-[1]'
  const [mobileMenu, setMobileMenu] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)
  const dealerContext = useContext(DealerContext)

  const handleMenuToggle = () => {
    setMobileMenu(!mobileMenu)
  }

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10)
    }
    handleScroll()

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <>
      <header className='text-sm h-20 group' data-mobile-menu={mobileMenu || null} data-is-scrolled={isScrolled || null}>
        <div className='fixed top-0 z-20 left-0 w-full px-12 max-xl:px-0 max-xl:shadow-xl transition-all duration-300 group-data-[is-scrolled]:px-0 max-xl:group-data-[mobile-menu]:bg-white'>
          <div className='relative bg-white transition-all duration-300 h-[72px] rounded-full px-4 flex items-center justify-between translate-y-4 max-xl:translate-y-0 max-xl:rounded-none group-data-[is-scrolled]:rounded-none group-data-[is-scrolled]:translate-y-0'>
            <PersistedLink to='/' className='w-[120px] md:w-[134px] block md:mx-6'>
              <img
                className='w-full'
                src={dealerContext?.themeLogo || '/brand/udc/site-logo.png'}
                alt='Logo'
              />
            </PersistedLink>
            <nav className='grow flex flex-row justify-end gap-6 lg:gap-10 h-full max-xl:right-0 lg:pr-8'>
              <p className='h-full flex items-center text-sm'>Applying for</p>
              <PersistedLink className={navLinkClasses} to='/personal' isNavLink onClick={handleMenuToggle}>
                Personal loan <ChevronDownIcon className='size-6 sm:hidden' />
              </PersistedLink>
              <PersistedLink className={navLinkClasses} to='/business' isNavLink onClick={handleMenuToggle}>
                Business loan <ChevronDownIcon className='size-6 sm:hidden' />
              </PersistedLink>
            </nav>
            <div className='sm:hidden absolute top-full right-4 bg-white shadow-lg p-4 pointer-events-none opacity-0 group-data-[mobile-menu]:pointer-events-auto group-data-[mobile-menu]:opacity-100'>
              <PersistedLink className={navLinkClassesMobile} to='/personal' isNavLink>
                Personal loans
              </PersistedLink>
              <PersistedLink className={navLinkClassesMobile} to='/business' isNavLink>
                Business loan
              </PersistedLink>
            </div>
          </div>
        </div>
      </header>
    </>
  )
}

export { Header }
